import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

export default class VerticalModalListHero extends React.PureComponent {
  static displayName = "VerticalModalListHero";

  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
  };

  render() {
    const className = classnames(
      "vertical-modal-list-hero",
      this.props.className,
    );

    return <div className={className}>{this.props.children}</div>;
  }
}
